import React from 'react'
import moment from 'moment';
import { useSelector } from 'react-redux'

export const Perfil = () => {
    const cliente = useSelector(state => state.client);
    const paquete= {...cliente.paquete};
    return (
        <div className="card">
            <div className="card-body text-center">

                <img src="/assets/images/perfil-default.jpg" className="rounded-circle avatar-xxl img-thumbnail mb-3" alt="profileImage" />
                <h4 className="mb-0">{cliente.nombre} {cliente.ape_paterno} {cliente.ape_materno} </h4>
                <p className="text-muted">Folio: {cliente.folio}</p>

                <div className="text-left mt-3">
                    <p className="text-muted mb-2 font-13">
                        <strong>Status :</strong>
                        <span className="ml-2">
                        <span 
                            className={`badge badge-${{'Activo': 'success', 'Pre-Cancelado': 'warning', 'Cancelado': 'danger'}[cliente.status]} font-13`}
                        >
                            {cliente.status}
                        </span>
                        </span>
                    </p>

                    <p className="text-muted mb-2 font-13"><strong>Telefono :</strong><span className="ml-2">{cliente.celular}</span></p>

                    <p className="text-muted mb-2 font-13"><strong>Email :</strong> <span className="ml-2 ">{cliente.correo}</span></p>

<                   p className="text-muted mb-1 font-13"><strong>Nombre del graduado :</strong> <span className="ml-2">{cliente.tutor}</span></p>

                    <br />

                    <h4 className="mb-4">Datos del Paquete</h4>

                    <p className="text-muted mb-2 font-13"><strong>Paquete :</strong><span className="ml-2 text-uppercase">{paquete.origen} - {paquete.destino} / {paquete.calendario} {paquete.anio}</span></p>

                    <p className="text-muted mb-2 font-13"><strong>Hotel :</strong> <span className="ml-2 text-uppercase">{paquete.hotel}</span></p>

                    <p className="text-muted mb-2 font-13"><strong>Fecha para liquidar :</strong> <span className="ml-2">{moment(paquete.liquidacion_normal).format('LL')}</span></p>


                </div>

                

            </div>
        </div>
        
    )
}
